const isRocket = process.env.CPA_ENV === 'rocket';

export const genAgesData = (d, ages, intl) => {
	return d.showEmptyAgeChart ? {
		labels: [intl('Нет данных')],
		datasets: [{
			data: [1],
			borderWidth: 0,
			backgroundColor: '#f0f0f0'
		}]
	} : {
		labels: ages.map(l => ` ${intl(l.title)}`),
		datasets: [{
			data: !isRocket ? [
				d.age_0_19, d.age_20_24, d.age_25_31, d.age_32_36, d.age_37_39, d.age_40_44, d.age_45_51,
				d.age_52_54, d.age_55_59, d.age_60_64, d.age_65_69, d.age_70_74, d.age_75_81, d.age_82
			] : [
				d.age_0_25, d.age_26_35, d.age_36_45, d.age_46_55, d.age_56_65, d.age_66_75, d.age_76
			],
			backgroundColor: ages.map(l => l.color),
			borderWidth: 0
		}]
	};
};

export const options = d => {
	return {
		responsive: false,
		maintainAspectRatio: false,
		cutoutPercentage: 65,
		title: {display: false},
		legend: {display: false},
		tooltips: {
			enabled: !d.showEmptyAgeChart,
			mode: 'nearest'
		},
		pieceLabel: {
			render: d.showEmptyAgeChart ? 'label' : 'percentage',
			showZero: true,
			fontSize: 16,
			fontFamily: "'ProximaNova-Bold'",
			fontColor: 'white',
			precision: 0
		}
	};
};



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/programs/info/components/Analytics/Diagram/helpers.js